// Shareable links for the Tech Debt Payback calculator, in `#techdebt=…` (see
// src/lib/share.js).

import { defineShare, num, obj, str } from "../lib/share.js";

const BIG = 1e6;
const range = (raw, lo, hi) => {
  const o = obj(raw);
  return { low: num(o.low, NaN, lo, hi), high: num(o.high, NaN, lo, hi) };
};

export const techDebtShare = defineShare({
  key: "techdebt",
  version: 1,
  docs: {
    summary: "Whether a refactor or other internal fix pays back: payback time and net benefit in team-days as ranges, the chance it pays back, and what measuring first is worth.",
    fields: {
      label: "Name of the fix; at most 120 characters.",
      principal: "Cost of the fix in team-days, as a 90% range { low, high } above 0.",
      interest: "Team-days lost each month to the debt now, as a 90% range { low, high } above 0.",
      recovered: "Share of that loss the fix wins back, in percent, as a range { low, high } within 0–100 (read as uniform).",
      horizonMonths: "Months to count savings over (1 to 120).",
      growthPct: "Yearly growth of the time lost, in percent (−90 to 500), e.g. as the area is changed more often.",
      replacePct: "Yearly chance, in percent (0 to 99), that the code is replaced or retired and the savings stop.",
    },
    caveats: [
      "Counts team time only; incidents, morale and hiring effects are not in the number unless you add them to the time lost.",
      "The ranges are treated as independent; a fix that is expensive because the area is tangled may also win back more.",
    ],
  },
  toState: (s) => ({
    label: s.label,
    principal: { ...s.principal },
    interest: { ...s.interest },
    recovered: { ...s.recovered },
    horizonMonths: s.horizonMonths,
    growthPct: s.growthPct,
    replacePct: s.replacePct,
  }),
  fromState: (raw) => ({
    label: str(raw.label, "This fix", 120),
    principal: range(raw.principal, 0, BIG),
    interest: range(raw.interest, 0, BIG),
    recovered: range(raw.recovered, 0, 100),
    horizonMonths: num(raw.horizonMonths, 12, 1, 120),
    growthPct: num(raw.growthPct, 0, -90, 500),
    replacePct: num(raw.replacePct, 0, 0, 99),
  }),
});
